export default __webpack_public_path__ + "static/media/Malefactor's Quarterstaff.d697b8e6.jpg";